/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/kycform.config.json";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";

import { StorageModule } from "@vlinder-web/storage-module-react";

const lookup = require("country-code-lookup");

const getGraphQLModule = (): GraphqlServerModule => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IKYCFormDataMethods extends IPluginMethodMap {
  getKYCFormDataContent(args: any): any;
}

export class AddNewKYCFormDataService implements IAgentPlugin {
  readonly methods: IKYCFormDataMethods;

  constructor() {
    this.methods = {
      getKYCFormDataContent: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    console.log("Args------> :", args)
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageSrv = StorageModule.getInstance();

    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_PROFILE,
          variables: { input: {} },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getMyProfile) {
          const _res = res.data.getMyProfile;
            storageSrv.set("myProfile", _res, "session");

          const filterKYCFields = config?.filterKYCIds ?? [];

          const filteredFields =
            config?.FIELDS?.filter((f) => filterKYCFields.includes(f.compProps?.id)) ||
            [];

          return {
            FIELDS: filteredFields,
            layout: config?.layout,
            validatorConfig: config?.validatorConfig,
            kycData: _res?.kyc || [],
            policyHolder: {
              firstName: _res?.firstName,
              lastName: _res?.lastName,
              email: _res?.email,
              telephone: _res?.primaryContactNo,
              streetAddress: _res?.address?.addressLine1,
              city: _res?.address?.city,
              country: _res?.address?.country
                ? lookup.byIso(_res?.address?.country)?.country
                : "-",
            },
            kycSubmitted: false,
            vuid: _res?.vuid,
          };
        }
      }
    } catch (err: any) {
      console.log(`AddNewKYCFormDataService user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }

    return { ...(config || {}) };
  }
}
